import { render, staticRenderFns } from "./Puzzle.vue?vue&type=template&id=e9274ecc&scoped=true&"
import script from "./Puzzle.vue?vue&type=script&lang=js&"
export * from "./Puzzle.vue?vue&type=script&lang=js&"
import style0 from "./Puzzle.vue?vue&type=style&index=0&id=e9274ecc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9274ecc",
  null
  
)

export default component.exports